import http from '@root/utils/axios/admin';

let state = {
    GameStoriesList: [],
    GameStory: {
        data: {},
        error: {}
    }
}

let actions = {

    fetchGameStoriesList({ commit }, filter = {}) {
        return new Promise((resolve, reject) => {
            http.get('user/game-stories', { params: filter }).then((response) => {
                commit('setGameStoriesList', response.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    deleteGameStory({ commit }, id) {
        return http.delete('user/game-stories/' + id);
    },

    fetchGameStory({ commit }, id) {
        return new Promise((resolve, reject) => {
            http.get('user/game-stories/' + id).then((response) => {
                commit('setGameStory', response.data.data);
                resolve(response);
            }).catch((errors) => {
                reject(errors);
            })
        })
    },

    CreateGameStory({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('user/game-stories', data).then((response) => {
                commit('setGameStory', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setGameStoryError', error.response.data);
                }
                reject(error.response);
            })
        });

    },

    updateGameStory({ commit }, data) {
        return new Promise((resolve, reject) => {
            http.post('user/game-stories/' + data.get('id'), data).then((response) => {
                commit('setGameStory', response.data);
                resolve(response);
            }).catch((error) => {
                if (error.response && error.response.status === 422) {
                    commit('setGameStoryError', error.response.data);
                }
                reject(error.response);
            })
        });
    },



}


let mutations = {
    setGameStoriesList(state, data) {
        state.GameStoriesList = data;
    },
    setGameStory(state, data) {
        state.GameStory.data = data;
    },
    setGameStoryError(state, error) {

        state.GameStory.error = error.errors;
    },
    cleanGameStoryError(state, error) {
        state.GameStory.error = {};
    },

}

export default {
    state,
    actions,
    mutations
}